export const deploymentConfig = {
  deploymentId: process.env.REACT_APP_DEPLOYMENT_ID,
};
